{
  "LoginPage": {
    "title": "Verify & Upload",
    "subtitle": "Let's keep this secure.\nJust need your code below.",
    "helperTitle": "Looking for your code?",
    "helperCopy": "We emailed it to you. Just let your loan advisor know if you can’t find it!",
    "cta": {
      "label": "Verify Me"
    },
    "pageTitle":"Login",
    "loginErrorTitle": "Hmm. That code doesn't match our records.",
    "loginErrorMessage": "If you would like us to resend your code, please check with your loan advisor.",
    "maintenanceMessage": "We're sorry, our upload portal is undergoing maintenance and is currently unavailable...",
    "genericErrorTitle": "An error has occurred.",
    "genericErrorMessage": "Your request couldn't be completed. Please try again later."
  },
  "ThankYouPage": {
    "title": "WooHoo!",
    "subtitle": "Thank you.\nWe will take it from here.",
    "cta": {
      "label": "Upload More",
      "url": "/upload"
    },
    "pageTitle":"Thank you"
  },
  "UploadPage": {
    "title": "Upload Documents.",
    "tabTitle": "Current Session",
    "helperTitle": "Drag your documents onto the browser window to start",
    "helperCopy": "We only accept plain Word, JPG, PNG, and PDF file types. Please do not password-protect these files.",
    "addButton": {
      "label": "Upload",
      "icon": "plus"
    },
    "finishButton": {
      "label": "I'm Done",
      "loadingLabel": "Uploading"
    },
    "pageTitle":"Upload"
  }
}

